import { SalesforceIconUrl } from "@p0security/integrations-salesforce-shared/icon";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { SalesforceAccesses } from "./accesses.ts";
import { SalesforceComponents } from "./components.ts";

export const salesforceFilters = {
  domain: { keys: ["value"] },
  "permission-set": { keys: ["id", "name"] },
} as const satisfies AnyFilterSchema;

export const SalesforceRegistration = Registration({
  accesses: SalesforceAccesses,
  category: "resource",
  components: SalesforceComponents,
  docs: {},
  filters: salesforceFilters,
  identifier: "My Domain name",
  itemKind: "organization",
  label: "Salesforce",
  logoUrl: SalesforceIconUrl,
  maturity: "preview",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("salesforce", SalesforceRegistration);
